import React, { useLayoutEffect, useState } from 'react';
import { createInstance, MatomoProvider } from '@datapunt/matomo-tracker-react';
import _get from 'lodash/get';
import backend from 'backend';

const UBTProvider = ({ children }) => {
    const [instance, setInstance] = useState({});

    useLayoutEffect(() => {
        (async () => {
            try {
                const res = await backend.ubt.config();
                const urlBase = `${_get(res.data, 'ubt.url', '')}/piwik/`;
                const siteId = _get(res.data, 'ubt.siteid', 0);
                const trackerUrl = `${urlBase}piwik.php`;
                const enable = _get(res.data, 'ubt.enable', false);

                enable && setInstance(createInstance({
                    urlBase,
                    siteId,
                    trackerUrl
                }));
            } catch (e) {
                console.log(e.toJSON());
            }
        })();
    }, []);

    return instance ? (
        <MatomoProvider value={instance}>
            {children}
        </MatomoProvider>
    ) : (
        children
    );
};

export default UBTProvider;
